import { JobApplicationStatus } from '../../../domain/types/jobApplicationStatus';
import { JobApplicationType } from '../../../domain/types/jobApplicationType';
import { PaginatedResult, PaginationParams, serializePagination } from '../../pagination';
import { API_JOB_APPLICATIONS_SERP_PATH, getClient } from '../api';
import { SerpJobApplication } from '../dtos';
import { serializeParams } from '../utils/serializer';

export enum EmailFilterStrategy {
  ASSIGNEE = 'ASSIGNEE',
  SUPERVISOR = 'SUPERVISOR',
  INTERVIEWER = 'INTERVIEWER',
}

export interface SerpJobApplicationProviderFilters {
  q?: string,
  toBeManaged?: boolean,
  toBeAssigned?: boolean,
  status?: JobApplicationStatus | JobApplicationStatus[],
  interviewDateGt?: string,
  interviewDateLt?: string,
  type?: JobApplicationType | JobApplicationType[],
  jobPositionId?: string | string[],
  province?: string | string[],
  emailFilter?: string | string[],
  emailFilterStrategy?: EmailFilterStrategy | EmailFilterStrategy[],
  createdAtGt?: string,
  createdAtLt?: string,
  source?: string | string[],
  isFranchising?: boolean,
  hasLicense?: boolean,
}

interface SerpJobApplicationsResponse {
  content: SerpJobApplication[],
  page: {
    size: number,
    number: number,
    totalElements: number,
    totalPages: number,
  },
}

export async function getSerpJobApplications(
  filters: SerpJobApplicationProviderFilters = {},
  pagination: PaginationParams = { size: 20 },
): Promise<PaginatedResult<SerpJobApplication>> {
  const client = await getClient();

  const { data }: { data: SerpJobApplicationsResponse } = await client.get(API_JOB_APPLICATIONS_SERP_PATH, {
    params: {
      ...serializeParams(filters),
      ...serializePagination(pagination),
    },
  });

  return {
    content: data.content,
    size: data.page.size,
    number: data.page.number,
    totalElements: data.page.totalElements,
    totalPages: data.page.totalPages,
    first: data.page.number === 0,
    last: data.page.number === data.page.totalPages - 1,
    numberOfElements: data.content.length,
  };
}
